export default "__VITE_ASSET__C9$VtOkJ__"